import { NgModule } from '@angular/core';
import { HTTPServicesModule } from '../../../http/src/services/http-services.module';
import { UZURVServicesModule } from './../../../core/src/services/uzurv-services.module';

@NgModule({
  imports: [HTTPServicesModule, UZURVServicesModule]
})
export class CLARAServicesModule {}
